import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import "firebase/storage"

// const production = window.location.hostname === 'metricswallet.com' || window.location.hostname === 'www.metricswallet.com';
let firebaseConfig = {
    apiKey: "AIzaSyDTSw-8048kIlFN9r-ORSBVuDIXh-Wn5EI",
  authDomain: "bantainapp.firebaseapp.com",
  projectId: "bantainapp",
  storageBucket: "bantainapp.firebasestorage.app",
  messagingSenderId: "2351255529",
  appId: "1:2351255529:web:d18fc9f3e1c2b83a6fc578",
  measurementId: "G-V39JHSY9GT"
};

const storageAppConfig = {
  apiKey: "AIzaSyALsZUfPNq2DybkxcEf-okBc5Kq3pf89XQ",
  authDomain: "footballprotips-d6a47.firebaseapp.com",
  projectId: "footballprotips-d6a47",
  storageBucket: "footballprotips-d6a47.firebasestorage.app",
  messagingSenderId: "789662337740",
  appId: "1:789662337740:web:13f97cdc6e37df57289069",
  measurementId: "G-5TSV5J8GRX"
};

firebase.initializeApp(firebaseConfig);
const storageApp = firebase.initializeApp(storageAppConfig, 'storage');

export const firestore = firebase.firestore;
export const storageRef = storageApp.storage().ref('bantainapp');
export const users_store = firestore().collection('users');
export const users_profile_store = firestore().collection('userProfiles');
export const transactions_store = firestore().collection('transactions');
export const receive_payments_store = firestore().collection('receivePayments');
export const send_payments_store = firestore().collection('sendPayments');
export const crypto_assets_store = firestore().collection('cryptoAssets');
export const fiat_assets_store = firestore().collection('fiatAssets');
export const wallet_addresses_store = firestore().collection('wallets');
export const supports_store = firestore().collection('support');
export const card_application_store = firestore().collection('cardApplications');
export const hw_application_store = firestore().collection('HWTokens');
export const contact_store = firestore().collection('contacts');
export default firebase